module.exports = __webpack_public_path__ + "static/media/BgFinish.4ec3681d.png";